var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px", persistent: "" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-cog")
                  ]),
                  _vm._v(" Envio automático de relatório de repasse e taxas "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharModal }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-6" },
                [
                  _c("Loading", {
                    attrs: { active: _vm.loading, "is-full-page": false }
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 primary--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "primary" } },
                                    [_vm._v("mdi-toggle-switch")]
                                  ),
                                  _vm._v(" CONFIGURAÇÃO GERAL ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-switch", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              label: "Ativar envio automático",
                                              color: "primary",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEnvio
                                                  .envioAutomaticoAtivo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEnvio,
                                                  "envioAutomaticoAtivo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEnvio.envioAutomaticoAtivo\n                                            "
                                            }
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption grey--text mt-2"
                                            },
                                            [
                                              _vm._v(
                                                " Quando ativado, os relatórios serão enviados automaticamente conforme a frequência configurada "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 info--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "info" } },
                                    [_vm._v("mdi-email-multiple")]
                                  ),
                                  _vm._v(" LISTA DE E-MAILS ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _vm._l(_vm.dadosEnvio.emails, function(
                                    email,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "mb-3" },
                                      [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "10" } },
                                              [
                                                _c("v-text-field", {
                                                  class: _vm.dadosEnvio
                                                    .envioAutomaticoAtivo
                                                    ? "editable-field"
                                                    : "readonly-field",
                                                  attrs: {
                                                    label: `E-mail ${index +
                                                      1}`,
                                                    type: "email",
                                                    disabled: !_vm.dadosEnvio
                                                      .envioAutomaticoAtivo,
                                                    rules: _vm.emailRules,
                                                    outlined: "",
                                                    dense: "",
                                                    placeholder:
                                                      "exemplo@empresa.com"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosEnvio.emails[
                                                        index
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosEnvio.emails,
                                                        index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "\n                                                    dadosEnvio.emails[index]\n                                                "
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "delete-button-container",
                                                attrs: { cols: "2" }
                                              },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function({
                                                            on,
                                                            attrs
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "",
                                                                        color:
                                                                          "error",
                                                                        disabled:
                                                                          !_vm
                                                                            .dadosEnvio
                                                                            .envioAutomaticoAtivo ||
                                                                          _vm
                                                                            .dadosEnvio
                                                                            .emails
                                                                            .length <=
                                                                            1
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.removerEmail(
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-delete"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Remover e-mail")
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                outlined: "",
                                                small: "",
                                                disabled: !_vm.dadosEnvio
                                                  .envioAutomaticoAtivo
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.adicionarEmail()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { small: "" }
                                                },
                                                [_vm._v("mdi-plus")]
                                              ),
                                              _vm._v(" Adicionar contato ")
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 success--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "success" } },
                                    [_vm._v("mdi-calendar-clock")]
                                  ),
                                  _vm._v(" FREQUÊNCIA DE ENVIO ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                disabled: !_vm.dadosEnvio
                                                  .envioAutomaticoAtivo,
                                                row: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.dadosEnvio
                                                    .frequenciaEnvio,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dadosEnvio,
                                                    "frequenciaEnvio",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                                                dadosEnvio.frequenciaEnvio\n                                            "
                                              }
                                            },
                                            [
                                              _c("v-radio", {
                                                staticClass: "mr-6",
                                                attrs: {
                                                  label: "Diário",
                                                  value: "diario",
                                                  color: "primary"
                                                }
                                              }),
                                              _c("v-radio", {
                                                staticClass: "mr-6",
                                                attrs: {
                                                  label: "Semanal",
                                                  value: "semanal",
                                                  color: "primary"
                                                }
                                              }),
                                              _c("v-radio", {
                                                staticClass: "mr-6",
                                                attrs: {
                                                  label: "Quinzenal",
                                                  value: "quinzenal",
                                                  color: "primary"
                                                }
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Mensal",
                                                  value: "mensal",
                                                  color: "primary"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption grey--text mt-2"
                                            },
                                            [
                                              _vm._v(
                                                " Selecione com que frequência deseja receber os relatórios automaticamente "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loading,
                        disabled: !_vm.validarForm() || _vm.loading
                      },
                      on: { click: _vm.salvarDados }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-content-save")
                      ]),
                      _vm._v(" Salvar dados ")
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "", disabled: _vm.loading },
                      on: { click: _vm.cancelarEdicao }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }